import axios from 'axios'
import { showError } from '@/util/helpers'
import store from '@/store'

const state = { loading: false }

const emptyAvailability = () => ({
  request: { pdf: false },
  fiscal: { pdf: false, xml: false },
  billing: { pdf: false },
})

const isDocumentNotFoundError = error => {
  const data = error?.response?.data
  const message = typeof data === 'string' ? data : data?.message
  return message === 'Documento não encontrado'
}

const actions = {
  create: async ({ state }, { type, id, mode = 'default', selection = null }) => {
    state.loading = true
    try {
      const companyId = store.get('authStore@currentCompany')?.id
      const { data } = await axios.post(`${process.env.VUE_APP_API_URL}/share?companyId=${companyId}`, { type, id, mode, selection, companyId })
      return data
    } catch (error) {
      showError(error)
      return null
    } finally {
      state.loading = false
    }
  },
  availability: async ({ state }, { type, id }) => {
    state.loading = true
    try {
      const companyId = store.get('authStore@currentCompany')?.id
      const { data } = await axios.post(`${process.env.VUE_APP_API_URL}/share/availability?companyId=${companyId}`, { type, id, companyId })
      return data
    } catch (error) {
      if (isDocumentNotFoundError(error)) {
        return emptyAvailability()
      }
      showError(error)
      return null
    } finally {
      state.loading = false
    }
  },
  sendEmail: async ({ state }, { type, id, selection }) => {
    state.loading = true
    try {
      const companyId = store.get('authStore@currentCompany')?.id
      const { data } = await axios.post(`${process.env.VUE_APP_API_URL}/share/email?companyId=${companyId}`, { type, id, selection, companyId })
      return data
    } catch (error) {
      showError(error)
      return null
    } finally {
      state.loading = false
    }
  },
}

export default { namespaced: true, state, actions }
